import React, { useState, useContext } from 'react';

import './UserFocus.css';
import '../../styles/colors.css';

import localize from '../../i18n/localize';
import callBackend from '../../utils/callBackend';
import LocalizedContext from '../../i18n/LocalizedContext';
import SearchFencer from '../search/SearchFencer';
import FocusedFencers from './FocusedFencers';
import FencerDetail from './FencerDetail';

const UserFocus = props => {
    const lang = useContext(LocalizedContext);

    const [focusedFencers, setFocusedFencers] = useState(props.focus);
    const [fencerDetail, setFencerDetail] = useState(null);

    // show details for the focused fencer
    const fencerHandler = fencer => {
        callBackend('focusDetail', {fencer}, result => {
            if( result.isOk ) {
                setFencerDetail({fencer, fencerDetail: result.data});
            }
        });
    };

    // add a fencer to focus
    const manuallyPickedFencerHandler = fencer => {
        if(fencer) {
            callBackend('focus', {fencer}, result => {
                if( result.isOk ) {
                    setFocusedFencers(result.data.focused);
                }
            });
        }
    };

    const addNoteHandler = (fencer, note) => {
        callBackend('focusAddNote', {fencer, note}, result => {
            if( result.isOk ) {
                setFencerDetail({fencer, fencerDetail: result.data});
            }
        });
    }

    const removeNoteHandler = (fencer, noteId) => {
        callBackend('focusDisposeNote', {noteId}, result => {
            if( result.isOk ) {
                setFencerDetail({fencer, fencerDetail: result.data});
            }
        });
    }

    const detail = fencerDetail ?
        <FencerDetail fencer={fencerDetail.fencer}
         details={fencerDetail.fencerDetail}
          addNoteHandler={addNoteHandler}
          removeNoteHandler={removeNoteHandler} />: '';

    return (
        <div>
            <div  className='UserFocus-envelope'>
                <div className='UserFocus-header'>
                    {localize(lang, 'focusedOpponents')}
                </div>
                <div className='UserFocus-description'>
                    {localize(lang, 'focusedOpponentsDetails')}
                </div>
                <div className='UserFocus-description'>
                    <SearchFencer setFencerHandler={manuallyPickedFencerHandler} />
                </div>
                <div className='UserFocus-description'>
                    <FocusedFencers focusedFencers={focusedFencers} fencerHandler={fencerHandler} />
                </div>
            </div>
            {detail}
        </div>
    );
};

export default UserFocus;